module.exports = __webpack_public_path__ + "static/img/preview.8395210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/game-table/preview.png
// module id = 92
// module chunks = 2